export type Inputs = {
  typeOfUpload: string;
  agentList: string;
  platform: {
    value: string;
    label: string;
  };
  justification: string;
};

export enum Labels {
  ALL = 'ALL',
  SLASH = 'Slash',
  AMEYO = 'Ameyo'
}

export const dropDownOptions = [
  {
    label: Labels.ALL,
    value: Labels.ALL
  },
  {
    label: Labels.SLASH,
    value: Labels.SLASH
  },
  {
    label: Labels.AMEYO,
    value: 'EXTENSION'
  }
];

export const PORTAL = 'LONGHORN';

export enum TYPE_OF_UPLOAD {
  MANUAL = 'manual',
  BULK = 'bulk'
}
